<template>
    <div class="mainpage">
        <div class="whitebox">
            <h1>Forgot Login</h1>

            <ul>
                <li class="t_center">Please write your associated email address so we can send instructions to reset
                    password.
                </li>
                <li>
                    <el-form @submit.native.prevent :rules="rules" :model="account" ref="ruleForm" style="font-size: 14px">
                        <el-form-item prop="email" style="width: 100%;height: auto;margin-bottom:0px;">
                            <input placeholder="Your email address" v-model.trim="account.email" type="email"
                                   @keydown.enter="check">
                        </el-form-item>
                    </el-form>
                </li>
                <li>
                    <button type="button" @click="check">Continue</button>
                </li>
            </ul>
        </div><!--whitebox end--->
    </div><!--mainpage end--->
</template>
<script>
    import util from '../util';
    import config from '../config';

    export default {
        name: "forgot_login",
        data() {
            return {
                account: {email: ''},
                rules: {
                    email: [{type: "email", message: 'Invalid format', trigger: 'blur'},
                        {required: true, message: 'Can\'t be empty', trigger: 'blur'}]
                }
            }
        },
        methods: {
            check() {
                this.$refs.ruleForm.validate(v => {
                    if (v)
                        util.axios.post(config.forgot_url, this.account).then(() => {
                            this.$router.push({path: '/rest_password'});
                        })
                })
            },
            goto() {
                this.$router.push('/rest_password');
            }
        }

    }
</script>

<style scoped>

</style>
